import { useRepo } from 'pinia-orm';
import { Model } from 'pinia-orm';
import { BelongsTo, HasMany, Num, Str } from 'pinia-orm/dist/decorators';
import Claim from './Claim';
import ProjectGroup from './ProjectGroup';
import SharedFundCost from './SharedFundCost';

export default class SharedFund extends Model {
  static entity = 'App\\Models\\SharedFund';

  @Num(0)
  declare id: number;
  @Num(0)
  declare project_group_id: number;
  @Str('')
  declare name: string;
  @Str('')
  declare code: string;
  @Num(0)
  declare budget: number;
  @Str('')
  declare created_at: string | undefined;
  @Str('')
  declare updated_at: string | undefined;
  @BelongsTo(() => ProjectGroup, 'project_group_id', 'id')
  declare project_group: ProjectGroup;
  @HasMany(() => SharedFundCost, 'shared_fund_id', 'id')
  declare costs: SharedFundCost[];

  public previous(claim: Claim): number {
    const projectIds = this.project_group?.projects?.map((project) => project.id) ?? [];

    if(projectIds.length === 0) {
      return 0;
    }

    const previousCosts = useRepo(SharedFundCost)
      .where('shared_fund_id', this.id)
      .whereHas('claim', (query) => {
        query.where('id', (id) => id !== claim.id)
          .where('project_id', (projectId) => projectIds.includes(projectId))
          .where('end', (end) => end < claim.end);
      })
      .get();

    return previousCosts.reduce((total, cost) => total + (cost.current_certified ?? 0), 0);
  }

  public remaining(claim: Claim, currentCertified = 0): number {
    return this.budget - this.previous(claim) - currentCertified;
  }
}
